<template>
  <Dialog
    :visible="visible"
    header="Transcript"
    modal
    class="transcript-dialog"
    :style="{ width: '40rem' }"
    @update:visible="$emit('update:visible', $event)"
  >
    <blockquote class="transcript-quote">
      <span class="transcript-ellipsis">&hellip;</span>
      {{ text }}
      <span class="transcript-ellipsis">&hellip;</span>
    </blockquote>
  </Dialog>
</template>

<script setup>
import Dialog from "primevue/dialog";

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  text: {
    type: String,
    default: "",
  },
});

defineEmits(["update:visible"]);
</script>

<style scoped>
.transcript-quote {
  position: relative;
  margin: 0;
  padding: 1.5rem 1.75rem;
  background: var(--surface-100);
  border-left: 4px solid var(--primary-color);
  border-radius: 0 var(--border-radius) var(--border-radius) 0;
  font-size: 1rem;
  line-height: 1.7;
  color: var(--text-color);
  white-space: pre-line;
  max-height: 24rem;
  overflow-y: auto;
}

.transcript-quote::before {
  content: "\201C";
  position: absolute;
  top: -0.5rem;
  left: 0.75rem;
  font-size: 4rem;
  font-family: Georgia, "Times New Roman", serif;
  color: var(--primary-color);
  opacity: 0.15;
  line-height: 1;
  pointer-events: none;
}

.transcript-ellipsis {
  color: var(--text-color-secondary);
  font-weight: 700;
  letter-spacing: 0.1em;
}
</style>
